import { useCallback, useEffect, useRef, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const KEY = "pkr-chat-session";

const getSessionId = () => {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(KEY, id);
  }
  return id;
};

export const useChat = () => {
  const [messages, setMessages] = useState([]);
  const [streaming, setStreaming] = useState(false);
  const sessionId = useRef(getSessionId());

  useEffect(() => {
    fetch(`${API}/api/chat/${sessionId.current}`)
      .then((r) => (r.ok ? r.json() : { messages: [] }))
      .then((d) => setMessages((m) => (m.length ? m : d.messages || [])))
      .catch(() => {});
  }, []);

  const send = useCallback(async (text) => {
    const content = text.trim();
    if (!content || streaming) return;
    setStreaming(true);
    setMessages((m) => [...m, { role: "user", content }, { role: "assistant", content: "" }]);
    const append = (delta) =>
      setMessages((m) => {
        const last = m[m.length - 1];
        if (!last || last.role !== "assistant") return m;
        return [...m.slice(0, -1), { ...last, content: last.content + delta }];
      });
    try {
      const res = await fetch(`${API}/api/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sessionId.current, message: content }),
      });
      if (!res.ok || !res.body) throw new Error("Request failed");
      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      for (;;) {
        const { value, done } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const parts = buffer.split("\n\n");
        buffer = parts.pop();
        for (const part of parts) {
          const line = part.replace(/^data: /, "");
          if (line === "[DONE]") continue;
          const evt = JSON.parse(line);
          if (evt.delta) append(evt.delta);
          if (evt.error) throw new Error(evt.error);
        }
      }
    } catch {
      append("Sorry, something went wrong. Please try again or book a call with us directly.");
    } finally {
      setStreaming(false);
    }
  }, [streaming]);

  return { messages, streaming, send };
};
